import { serializable, alias, list, object } from 'serializr';

export class EmissionData {
  @serializable
  scope?: string;

  @serializable
  value?: number;

  @serializable
  percentage?: number;
}

export class EmissionResponse {
  @serializable(alias('scope_emission', list(object(EmissionData))))
  scopeEmission?: EmissionData[];
}
